import { useState, useEffect } from "react";
import { Btn, Card, Inp, Lbl, ConfirmModal } from "../ui";
import { sigteApiFetch, sigteApiFetchChecked } from "./sigteUtils";

var SIGTE_BRAND = "#0F2C70";
var BLANK = {nombre:"",rfc:"",direccion:"",contacto:"",correo:"",telefono:"",contrato:""};

export function SigteClientes(p) {
  var [clientes,setClientes]=useState([]);
  var [loading,setLoading]=useState(true);
  var [view,setView]=useState("list");
  var [editing,setEditing]=useState(null);
  var [form,setForm]=useState(BLANK);
  var [err,setErr]=useState("");
  var [confirmData,setConfirmData]=useState(null);

  function load(){
    sigteApiFetch("/clientes").then(function(r){return r.json();}).then(function(d){
      setClientes(d.clientes||[]); setLoading(false);
    });
  }
  useEffect(load,[]);

  function setF(k,v){ setForm(function(f){return Object.assign({},f,{[k]:v});}); }
  function ask(msg,fn){ setConfirmData({msg:msg,fn:fn}); }

  function startNew(){ setEditing(null); setForm(BLANK); setErr(""); setView("edit"); }
  function startEdit(c){ setEditing(c); setForm(Object.assign({},BLANK,c)); setErr(""); setView("edit"); }

  async function save(){
    if(!form.nombre.trim()){setErr("El nombre es requerido.");return;}
    var path = editing ? "/clientes/"+editing.id : "/clientes";
    var method = editing ? "PUT" : "POST";
    try {
      await sigteApiFetchChecked(path,{method:method,body:JSON.stringify(form)});
      setView("list"); load();
    } catch(e) {
      setErr(e.message);
    }
  }

  function del(c){
    ask('Eliminar "'+c.nombre+'"? Se eliminaran tambien sus edificios y equipos.', async function(){
      try {
        await sigteApiFetchChecked("/clientes/"+c.id,{method:"DELETE"});
        load();
      } catch(e) {
        setErr(e.message);
      }
    });
  }

  if(loading) return <p style={{color:"#64748b",fontSize:14}}>Cargando...</p>;

  return (
    <div>
      <ConfirmModal data={confirmData} onCancel={function(){setConfirmData(null);}} onConfirm={function(){if(confirmData)confirmData.fn();setConfirmData(null);}}/>
      {view==="list"?(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
            <div><h1 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:0}}>Clientes</h1><p style={{color:"#64748b",fontSize:13,marginTop:3}}>{clientes.length+" clientes"}</p></div>
            <Btn onClick={startNew}>+ Nuevo cliente</Btn>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {clientes.map(function(c){
              return (
                <Card key={c.id} sx={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
                  <div style={{cursor:"pointer",flex:1}} onClick={function(){p.onOpenCliente(c);}}>
                    <p style={{margin:0,fontWeight:700,fontSize:14,color:"#0f172a"}}>{c.nombre}</p>
                    <p style={{margin:"2px 0 0",fontSize:12,color:"#64748b"}}>{(c.rfc||"Sin RFC")+" · "+(c.contacto||"Sin contacto")}</p>
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <button onClick={function(){p.onOpenCliente(c);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #dde3f0",background:"#fff",color:SIGTE_BRAND,fontSize:12,fontWeight:600,cursor:"pointer"}}>Ver edificios</button>
                    <button onClick={function(){startEdit(c);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #dde3f0",background:"#fff",color:"#374151",fontSize:12,fontWeight:600,cursor:"pointer"}}>Editar</button>
                    <button onClick={function(){del(c);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #fecaca",background:"#fef2f2",color:"#dc2626",fontSize:12,fontWeight:600,cursor:"pointer"}}>Eliminar</button>
                  </div>
                </Card>
              );
            })}
            {clientes.length===0?<p style={{color:"#94a3b8",fontSize:13}}>No hay clientes registrados.</p>:null}
          </div>
        </div>
      ):(
        <div>
          <h1 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:"0 0 24px"}}>{editing?"Editar cliente":"Nuevo cliente"}</h1>
          <Card>
            {err?<div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 16px",fontSize:13,color:"#dc2626",marginBottom:16}}>{err}</div>:null}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:20}}>
              <div><Lbl c="Nombre"/><Inp value={form.nombre} onChange={function(e){setF("nombre",e.target.value);}}/></div>
              <div><Lbl c="RFC"/><Inp value={form.rfc} onChange={function(e){setF("rfc",e.target.value);}}/></div>
              <div><Lbl c="Contacto"/><Inp value={form.contacto} onChange={function(e){setF("contacto",e.target.value);}}/></div>
              <div><Lbl c="Correo"/><Inp value={form.correo} onChange={function(e){setF("correo",e.target.value);}}/></div>
              <div><Lbl c="Telefono"/><Inp value={form.telefono} onChange={function(e){setF("telefono",e.target.value);}}/></div>
              <div><Lbl c="Contrato"/><Inp value={form.contrato} onChange={function(e){setF("contrato",e.target.value);}}/></div>
              <div style={{gridColumn:"1 / -1"}}><Lbl c="Direccion"/><Inp value={form.direccion} onChange={function(e){setF("direccion",e.target.value);}}/></div>
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={function(){setView("list");}} style={{flex:1,padding:"11px 0",borderRadius:9,border:"1px solid #e2e8f0",background:"#fff",color:"#64748b",fontWeight:600,fontSize:13,cursor:"pointer"}}>Cancelar</button>
              <Btn onClick={save} sx={{flex:2,padding:"11px 0",borderRadius:9,fontSize:14}}>Guardar cliente</Btn>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}
